export default __webpack_public_path__ + "static/media/stepBlogger-3.07c24e2f.svg";